var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-content",
      attrs: { id: _vm.id },
      on: { mousedown: _vm.focus, touchstart: _vm.focus }
    },
    [
      _c(
        "div",
        {
          staticClass: "focus-mark",
          class: { "focus-mark--focused": _vm.hasFocus }
        },
        [
          _c(
            "div",
            { staticClass: "image-content__container" },
            [
              _c(
                "div",
                { staticClass: "image-content__handle tooltip-drag-handle" },
                [
                  _vm.imageUrl
                    ? _c("img", {
                        staticClass: "image-content__container__image",
                        attrs: { src: _vm.imageUrl }
                      })
                    : _c("img", {
                        staticClass: "image-content__container__image",
                        attrs: {
                          src: require("../../assets/img/noImage.png"),
                          alt: "画像データがありません"
                        }
                      })
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "menu-effect" } }, [
                _vm.hasFocus
                  ? _c("div", { staticClass: "menu-container" }, [
                      _vm.menuMode === "top"
                        ? _c("div", { staticClass: "menu-container__item" }, [
                            _c(
                              "label",
                              {
                                staticClass: "menu-button tooltip-change-image"
                              },
                              [
                                _c("span", { staticClass: "fi-loop" }),
                                _vm._v(" "),
                                _c("input", {
                                  staticStyle: { display: "none" },
                                  attrs: {
                                    type: "file",
                                    accept: "image/jpeg,image/png,image/gif"
                                  },
                                  on: { change: _vm.onFileUploaded }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "menu-button tooltip-edit-link",
                                on: { click: _vm.openMenuLink }
                              },
                              [_c("span", { staticClass: "fi-link" })]
                            ),
                            _vm._v(" "),
                            _vm.linkUrl
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "menu-button tooltip-edit-unlink",
                                    on: { click: _vm.removeLink }
                                  },
                                  [_c("span", { staticClass: "fi-unlink" })]
                                )
                              : _vm._e()
                          ])
                        : _vm.menuMode === "link"
                          ? _c("div", { staticClass: "menu-container__item" }, [
                              _c("div", { staticClass: "link-menu" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "link-menu__back",
                                    on: {
                                      click: function($event) {
                                        _vm.openMenuTop()
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "link-menu__label" },
                                  [_vm._v("URL:")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.editingLinkUrl,
                                      expression: "editingLinkUrl"
                                    }
                                  ],
                                  ref: "linkUrl",
                                  staticClass: "link-menu__input",
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.editingLinkUrl },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !("button" in $event) &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.updateLink($event)
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.editingLinkUrl = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "link-menu__submit",
                                    attrs: { disabled: !_vm.isUrlValid },
                                    on: { click: _vm.updateLink }
                                  },
                                  [_vm._v("更新")]
                                ),
                                _vm._v(" "),
                                !_vm.isUrlValid && !!_vm.editingLinkUrl
                                  ? _c(
                                      "p",
                                      { staticClass: "link-menu__error" },
                                      [
                                        _vm._v(
                                          "URLを正しい形式で入力して下さい。(https://example.com/index.html)"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _vm._e()
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "link-effect" } }, [
            _vm.hasFocus && _vm.linkUrl
              ? _c("div", { staticClass: "link-container" }, [
                  _c(
                    "p",
                    {
                      staticClass: "link-container__url",
                      attrs: { title: _vm.linkUrl }
                    },
                    [
                      _c("span", { staticClass: "fi-link" }),
                      _vm._v(" " + _vm._s(_vm.linkUrl))
                    ]
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "image-content__delete tooltip-delete-image",
                on: {
                  click: function($event) {
                    _vm.deleteComponent()
                  }
                }
              },
              [_vm._v("×\n      ")]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }